const coinPics = symbol => `/img/coins/${symbol}.png`

export default coinPics
